import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface LeadOrigensProps extends QueryGlobalInterface {
  enabled?: boolean;
  idLeadCorretor?: string;
}

export function useLeadOrigens(props: LeadOrigensProps) {
  const fetchData = async () => {
    const LEAD_ORIGENS = `leads/commom/leads/origens/v1/${props.idLeadCorretor}`;
    const response = await instance.get(LEAD_ORIGENS);

    return response?.data || null;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled !== undefined ? props.enabled : false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar origens do lead. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
